export function createDustEffect(k, parent) {
    const dust = parent.add([
        k.sprite("littleDust"),
        k.z(90),
        k.opacity(1),
        k.anchor("center"),
        k.pos(0, 5),
        k.scale(1.8),
    ]);
    dust.play("spawn");
    dust.onAnimEnd(() => dust.destroy());
    return dust;
}